import { ProjectResponse } from '@/typing/api/projectsResponse.class';
import { Report } from '@/typing/api/report.class';
import { Trip } from '@/typing/api/tripNew.class';
import { isUndefined } from '@/utils/isUndefined';
import dayjs from 'dayjs';

export class ProjectStatisticsModel {
    amountOfTrips: number;
    daym3: number;
    totalDay: number;
    totalProject: number;

    constructor(p?: ProjectStatisticsModel) {
        this.amountOfTrips = p?.amountOfTrips ?? 0;
        this.daym3 = p?.daym3 ?? 0;
        this.totalDay = p?.totalDay ?? 0;
        this.totalProject = p?.totalProject ?? 0;
    }

    fillModel(
        projectId: number,
        shipId: number,
        projectData?: ProjectResponse,
        boxNumber?: number
    ): ProjectStatisticsModel {
        if (!projectData || isUndefined(projectId) || isUndefined(shipId))
            return this;

        const dateStringFormat = 'YYYY-MM-DD';
        const dayFilter = (t: Trip) =>
            t.date === dayjs().format(dateStringFormat);
        const report = projectData.getReport(projectId, shipId);
        const tripsForBoxNumber: Trip[] = [];

        projectData.reports.forEach((r: Report) => {
            r.trips.forEach((t: Trip) => {
                if (!boxNumber) {
                    tripsForBoxNumber.push(t);
                } else if (t.boxNumber?.toString() === boxNumber.toString()) {
                    tripsForBoxNumber.push(t);
                }
            });
        });

        const dayTripsForBoxNumber = tripsForBoxNumber.filter(dayFilter);
        const dayTrips = report?.trips.filter(dayFilter) ?? [];

        this.amountOfTrips = tripsForBoxNumber.length ?? 0;
        this.daym3 = this._getVolumeFromTrips(dayTripsForBoxNumber);
        this.totalDay = this._getVolumeFromTrips(dayTrips);
        this.totalProject = this._getVolumeFromTrips(report?.trips ?? []);

        return this;
    }

    private _getVolumeFromTrips(trips: Trip[]): number {
        return trips
            .flatMap((t: Trip) => t?.volume ?? 0)
            .reduce(
                (previousValue: number, currentValue: number) =>
                    Number(currentValue) + Number(previousValue),
                0
            );
    }
}
